import React, { useCallback, useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Room } from './Room'
import { useMutation } from '@apollo/client'
import config from '../../config'
import END_REQUEST from '../../graphql/Requests/mutations/EndRequest'
import LiveContext from '../../components/Context/LiveContext'
import { useNavigate } from 'react-router-dom'
import api from '../../api'
import dayjs from 'dayjs'

export const VideoChat = ({ room, setRoom }) => {
  const { toggleLivePreview } = useContext(LiveContext)
  const navigate = useNavigate()

  const [durationLive, setDurationLive] = useState(1)

  const [endRequest, { data: requestEnded }] = useMutation(END_REQUEST, {
    onCompleted: () => {
      navigate(`/live-rating/${requestEnded.updateRequest.request.id}`)
    },
    onError: () => {
      const idRequest = localStorage.getItem('idRequest')
      navigate(`/live-rating/${idRequest}`)
    },
  })

  const handleLogout = useCallback(async (pause) => {
    const now = new Date()

    setRoom((prevRoom) => {
      if (prevRoom) {
        prevRoom.disconnect()
      }
      return null
    })

    const dateTimeRangeLive = JSON.parse(
      localStorage.getItem('dateTimeRangeLive')
    )

    if (!pause) {
      const idRequest = localStorage.getItem('idRequest')
      api.post(`${config.API_BASE_URL}/requests/${idRequest}/room/complete`)

      endRequest({
        variables: {
          input: {
            id: idRequest,
            patch: {
              status: 'OVER',
              datetimeRange: {
                start: {
                  value: dateTimeRangeLive.start.value,
                  inclusive: true,
                },
                end: { value: dayjs(now).toISOString(), inclusive: true },
              },
            },
          },
        },
      })
      toggleLivePreview(false)
    }
  }, [])

  useEffect(() => {
    if (room) {
      const tidyUp = (event) => {
        if (event.persisted) {
          return
        }
        if (room) {
          handleLogout(true)
        }
      }
      window.addEventListener('pagehide', tidyUp)
      window.addEventListener('beforeunload', tidyUp)
      return () => {
        window.removeEventListener('pagehide', tidyUp)
        window.removeEventListener('beforeunload', tidyUp)
      }
    }
  }, [room, handleLogout])

  return (
    <Room
      room={room}
      durationLive={durationLive}
      setDurationLive={setDurationLive}
      handleLogout={handleLogout}
    />
  )
}

VideoChat.propTypes = {
  room: PropTypes.any,
  setRoom: PropTypes.any,
}
